// extracted by mini-css-extract-plugin
export default {"ohneabstand":"ButtonNew_ohneabstand__JqzSe","button":"ButtonNew_button__hXHpI","icon":"ButtonNew_icon__0feRc","head":"ButtonNew_head__yBpUy"};